/* eslint-disable max-len */
import React, { useEffect, useRef, useState } from 'react';
import styled, { css, keyframes } from 'styled-components';
import { Colors } from '../patterns/Colors';

const CheckFlash = () => {
    return keyframes`
        from { opacity: 1; transform: scale(1); box-shadow: .0rem .0rem .0rem .0rem #40B8A8; }
        to { opacity: 0; transform: scale(2); box-shadow: .0rem .0rem .325rem .325rem #40B8A8; }
    `;
};

const Frame = styled.div<{ value?: boolean, animate: boolean }>`
    display: inline-block;
    vertical-align: top;
    position: relative;
    width: 1.5rem;
    height: 1.5rem;

    ${({ animate }) =>
        animate &&
        css`
            &:before {
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                right: 0;
                bottom: 0;
                background: #40B8A8;
                border-radius: 50%;
                animation: ${CheckFlash} 0.5s ease-out;
            }
        `
    }

    svg {
        position: absolute;
        width: 100%;
        height: 100%;
    }
`;

const Off = () =>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <circle fill="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" stroke="gainsboro" cx="12" cy="12" r="10.5" />
    </svg>;

const On = ({ color }: { color?: string }) =>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <circle fill={color ?? Colors.positive} cx="12" cy="12" r="12" />
        <g transform="translate(3, 4) scale(.75)">
            <polyline fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" points="20 6 9 17 4 12"></polyline>
        </g>
    </svg>;


const Base = React.memo<{ value?: boolean }>(({ value }) => {

    const firstRender = useRef(true);
    const [animate, setAnimate] = useState(false);
    const [key, setKey] = useState(() => crypto.randomUUID());

    useEffect(() => {
        if (value && !firstRender.current) {
            setKey(crypto.randomUUID());
            setAnimate(true);
        }
    }, [value]);

    useEffect(() => {
        firstRender.current = false;
    }, []);

    return <Frame key={key} value={value} animate={animate}>
        {value ? <On /> : <Off />}
    </Frame>;
});

export const Check = Object.assign(Base, {
    Frame,
    On,
    Off
});
